import { Dimension } from './dimension';
import { Sachgebiet } from './sachgebiet';

export class FactTable {

    id?: string;
    caption?: string;
    systeminfoid?: number; // rausnehmen?
    sachgebiet?: Sachgebiet;
    tablename?: string;
    conformedDimensions: Dimension[] = []; 
    description?: string = '';
    disabled?: boolean = false;

    constructor(id: string, caption: string, description: string){
        this.id = id;
        this.caption = caption;
        this.description = description;
    }


    dbtDocsUrl(): string {
        return '/superx/dbt/projects/hisinone/transform/target/index.html#!/model/model.hisinone.'
         + this.tablename;
    }

    static createFromObject(obj: any): FactTable {
        let result = new FactTable(obj.id!, obj.caption!, obj.description!);
        Object.assign(result, obj);
        return result;
    }

    // used for testing purposes
    static getMockFactTable(id: string){
        return new FactTable(id, '', '');
    }
}
